module.exports = __webpack_public_path__ + "img/second-cup.0ef13943.png";